"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentProNumberChangedEvent = void 0;
const ShipmentEventType_1 = require("../ShipmentEventType");
const BaseCloudEvent_1 = require("./BaseCloudEvent");
class ShipmentProNumberChangedEvent extends BaseCloudEvent_1.BaseCloudEventV1 {
    constructor(id, data, source = BaseCloudEvent_1.DEFAULT_SOURCE) {
        super(id);
        this.type = ShipmentEventType_1.ShipmentFctEventType.ShipmentProNumberChanged;
        this.data = data;
        this.source = source;
    }
}
exports.ShipmentProNumberChangedEvent = ShipmentProNumberChangedEvent;
//# sourceMappingURL=ShipmentProNumberChangedEvent.js.map